import { MultiSelect } from "primereact/multiselect";
import { Establishment } from "../../../../interface/interface";

interface LocationEstablishmentFilterProps {
    establishments: Establishment[];
    selectedEstablishmentIds: number[];
    onChange: (next: number[]) => void;
    placeholder?: string;
}

export default function LocationEstablishmentFilter({
    establishments,
    selectedEstablishmentIds,
    onChange,
    placeholder = "Seleccionar establecimientos",
}: Readonly<LocationEstablishmentFilterProps>) {
    const totalEstablishments = establishments?.length ?? 0;

    const selectedCount = selectedEstablishmentIds?.length ?? 0;
    const allSelected = totalEstablishments > 0 && selectedCount === totalEstablishments;

    return (
        <div className="location-mobile-filter mb-3">
            <label className="block mb-2 mt-4">Establecimientos</label>
            <MultiSelect
                className="w-full"
                options={establishments ?? []}
                optionLabel="buildingname"
                optionValue="buildingid"
                value={selectedEstablishmentIds ?? []}
                onChange={(e) => onChange((e.value ?? []) as number[])}
                placeholder={placeholder}
                showClear
                filter
                display={allSelected ? "comma" : "chip"}
                maxSelectedLabels={allSelected ? 0 : 2}
                selectedItemsLabel={allSelected ? "Todos" : "{0} seleccionados"}
            />
        </div>
    );
}
